<script lang="ts">
	import { format } from 'svelte-i18n';
	import PremiumUpsellAlert from 'src/components/Premium/PremiumUpsellAlert.svelte';

	// svelte-ignore unused-export-let
	export let showAboutAIModelModal = false,
		device;
</script>

<PremiumUpsellAlert
	{device}
	isHeadingBold
	heading={$format('title_upgrade_to_premium_for_feature', {
		default: 'Upgrade to Premium!',
	})}
	subHeading={$format('text_upgrade_to_premium_for_feature', {
		default: 'In order to use this feature, you need to become a premium user.',
	})}
/>
